import { Component, OnInit, OnDestroy } from '@angular/core';
import { userProfile } from '../../../../models/userProfile';
import { Router } from '@angular/router';
import { AdminService } from '../../../../services/Admin.service';
import { NgForm, NgModel } from '@angular/forms';
import { ConfirmationPageSuccessComponent } from '../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from '../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { BusyIndicatorComponent } from '../../../../shared-components/busy-indicator/busy-indicator.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataService } from '../../../../services/data.service';

@Component({
  selector: 'app-my-profile-v',
  templateUrl: './my-profile-v.component.html',
  styleUrls: ['./my-profile-v.component.scss']
})
export class MyProfileVComponent implements OnDestroy, OnInit {
  userProfile: userProfile = new userProfile();
  custLogin: any;
  alive = true;
  public errorMsg: string;
  public successMsg: string;
  public showSuccessConfirmation = false;
  public showFailConfirmation = false;

  constructor(private router: Router,
    private _dataSvc: DataService,
    private adminSvc: AdminService,
    private spinner: NgxSpinnerService ) { }

  ngOnInit() {
    this.getUserInfo();
  }

  getUserInfo() {
    this.adminSvc.getUserInfo()
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          this.userProfile.Email = data.Email;
          this.userProfile.OldEmail = data.Email;
          this.userProfile.Fax = data.Fax;
          this.userProfile.OldFax = data.Fax;
          this.userProfile.Phone = data.Phone;
          this.userProfile.OldPhone = data.Phone;
          this.showFailConfirmation = false;
          this.showSuccessConfirmation = false;
        },
        err => {
          this.showFailConfirmation = true;
          this.showSuccessConfirmation = false;
          this.errorMsg = err;
        }
      );
  }

  goToVendorHome(event) {
    this.router.navigate(['/pages/vendor/myvendor/home']);
  }

  close(event) {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  onSubmit(frmUpdProfile: NgForm) {
    this.errorMsg = null;
    this.successMsg = null;
    this.spinner.show();
    this.userProfile.bearerToken = this._dataSvc.userDisplayInfo.bearerToken;
    this.userProfile.id = this._dataSvc.userDisplayInfo.id;
    this.adminSvc.ChangeProfile(this.userProfile)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
                this.spinner.hide();
                this.showFailConfirmation = false;
                this.showSuccessConfirmation = true;
                this.successMsg = 'Your profile was updated successfully.';
                this.errorMsg = null;
          },
      err => {
          this.spinner.hide();
          this.showFailConfirmation = true;
          this.showSuccessConfirmation = false;
          this.successMsg = null;
          this.errorMsg = err;
        }
    );
  }

  ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-settings-v/my-profile-v/my-profile-v.component.ts